import React from 'react'

const Overlay = ({ children, onClick }) => {
    const overlayStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
    };

    return (
        <div style={overlayStyle} onClick={onClick}>{children}</div>
    )
}

export default Overlay